// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// #region MessageBox
export let showMessageBoxAsync;
export function setMessageBoxAsyncHandler(handler) {
    showMessageBoxAsync = handler;
}
export let showCertificateScreenAsync;
export function setCertificateScreenHandler(handler) {
    showCertificateScreenAsync = handler;
}
// #endregion
